(() => {
  const updateHeader = () => document.querySelector('.cleanjawhp-header')?.classList.toggle('cleanjawhp-header--scrolled', window.scrollY > 120);
  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('click', event => {
    document.querySelectorAll('.cleanjawhp-nav-branch[open]').forEach(branch => {
      if (!branch.contains(event.target)) branch.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = event.target.closest('.cleanjawhp-nav-branch[open], .cleanjawhp-mobile-menu[open]');
    if (!openMenu) return;
    openMenu.open = false;
    openMenu.querySelector('summary').focus();
    event.preventDefault();
  });
  const setup = (root = document) => {
    root.querySelectorAll('.cleanjawhp-kcs__gallery, .cleanjawhp-krs__gallery').forEach(gallery => {
      if (gallery.dataset.cleanjawReady) return;
      gallery.dataset.cleanjawReady = 'true';
      const track = gallery.querySelector('.cleanjawhp-kcs__track, .cleanjawhp-krs__track');
      const buttons = gallery.querySelectorAll('.cleanjawhp-kcs__navigation button, .cleanjawhp-krs__nav button');
      if (!track || buttons.length < 2) return;
      const update = () => {
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      buttons[0].addEventListener('click', () => track.scrollBy({ left: -(track.firstElementChild?.getBoundingClientRect().width || track.clientWidth), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
      buttons[1].addEventListener('click', () => track.scrollBy({ left: track.firstElementChild?.getBoundingClientRect().width || track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('.cleanjawhp-kcs__toggle').forEach(button => {
      if (button.dataset.cleanjawReady) return;
      button.dataset.cleanjawReady = 'true';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.closest('.cleanjawhp-kcs__card').querySelector('.cleanjawhp-kcs__text').classList.toggle('cleanjawhp-is-open', expanded);
      });
    });
    root.querySelectorAll('.cleanjawhp-currency select').forEach(select => {
      if (select.dataset.cleanjawReady) return;
      select.dataset.cleanjawReady = 'true';
      select.form.querySelector('.cleanjawhp-currency-submit').hidden = true;
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  };
  document.addEventListener('DOMContentLoaded', () => { setup(); updateHeader(); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();


